import React from 'react';
import PropTypes from 'prop-types';

const DesignWrapper = ({ newDesignComponent }) => (
  <div id='lcr__wrapper'>
    {newDesignComponent}
  </div>
);

DesignWrapper.propTypes = {
  newDesignComponent: PropTypes.element.isRequired,
};

DesignWrapper.defaultProps = {
  newDesignComponent: null,
};

export default DesignWrapper;
